import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Shift } from 'modules/shift_management/lib/types'

import { useFormatDates } from '../../utils'

interface Props {
  shift: Shift
  date: moment.Moment
}

const Basic = ({ shift, date }: Props) => {
  const [{ view }] = useSchedule()
  const formatDates = useFormatDates()
  const inRange = shift.inRange(view.firstDay, view.lastDay)
  const nightShiftPeriodBefore = shift.isNightShift && !inRange
  const dates = formatDates(shift, date, nightShiftPeriodBefore)

  return (
    <Box flexDirection="column" alignItems="flexStart">
      <Text.Normal size="100" weight="medium" color="grey1000">
        {dates.startAt}
      </Text.Normal>
      <Text.Normal size="100" weight="medium" color="grey1000">
        {dates.endAt}
      </Text.Normal>
    </Box>
  )
}

export default observer(Basic)
